import { useCallback } from 'react';
import { withProps } from 'recompose';
import { prop } from 'ramda';
import { useAppSelector } from 'js/store/hooks';
import withParsedLeaderBoardRules from '../reducers/withParsedLeaderBoardRules';
import detailsReducer from '../reducers/details';

export default withProps(
    () => {
        const games = useAppSelector(prop('games'));
        const reducer = useCallback((state, action) => withParsedLeaderBoardRules({ games })(detailsReducer)(state, action),
            [games]
        );

        return {
            reducer
        };
    }
);
